import React from 'react';
import styled from '@emotion/styled';

const Container = styled.div`
  color: ${props => props.theme.colors.dark};
  margin: ${props => props.theme.size.medium} auto;
  padding-left: ${props => props.theme.size.medium};
  width: 1000px;
`

const Header = styled.header`
  display: flex;
  align-items: flex-end;
`

const Name = styled.p`
  font-weight: 700;
  font-size: ${props => props.theme.size.xlarge};
  text-transform: uppercase;
`;

const Logo = styled.img`
  margin-right: 10px;
  width: 100px;
`

const Tagline = styled.span`
  font-size: 14px;
  display: block;
  padding-top: ${props => props.theme.size.xsmall};
  padding-bottom: 5px;
  text-transform: none;
  font-weight: 100;
`

const Intro = styled.h2`
  line-height: 40px;
  margin: 100px auto;
  text-align: center;
  width: 90%;
`

class LandingPage extends React.Component {
  render() {
    return (
      <Container>
        <Header>
          <Logo src="media/lapduck.svg" />
          <div>
            <Name>LAP</Name>
            <Tagline>lap lap the sound of the wings of knowledge</Tagline>
          </div>
        </Header>
        { this.props.intro && <Intro>We all hate to study, let's be honest. Why not reduce the pain and let technology help you out.</Intro> }
      </Container>
    );
  }
}

export default LandingPage;
